import React from "react";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import fullAvatar from "../../assets/images/full_avatar.png";
import whatsappLogo from "../../assets/images/whatsapp_logo.png";

export function CardAvatar(props) {
    return (
        <ContentCard style={{ backgroundColor: "#30303d", color: "#fff" }}>
            <a href="https://wa.me/5555996214926?text=Olá, gostaria de mais informações!" target="_blank" rel="noopener noreferrer" style={{ color: "#FFF" }}>
                <ContentCardBody
                    padding="0"
                    style={{
                        backgroundColor: "#30303d",
                        height: 550,
                        overflowX: "hidden",
                        overflowY: "scroll",
                    }}
                >
                    <div
                        title="Entrar em contato pelo WhatsApp"
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img style={{ zIndex: 3 }} src={fullAvatar} alt="Gestão Inteligente de Faturas e Usinas" height="80%" />
                        <h5
                            style={{
                                backgroundColor: "#26222b",
                                width: "100%",
                                justifyContent: "center",
                                display: "flex",
                                flexGrow: 1,
                                marginTop: "-7px",
                                zIndex: 2,
                                boxShadow: "0px 0px 5px 6px #21202a",
                                paddingTop: 40,
                            }}
                        >
                            <img style={{ marginTop: -10 }} src={whatsappLogo} alt="" height={40} /> Gestão Inteligente de Faturas e Usinas
                        </h5>
                    </div>
                </ContentCardBody>
            </a>
        </ContentCard>
    );
}
